// extracted by mini-css-extract-plugin
export default {"root":"PlasmicLastMonthDataButton_root__51ean","text":"PlasmicLastMonthDataButton_text__jO8XC"};